import { createStore } from 'vuex'
import { getSchoolListByUser, getAdminAuth } from '@/api/admin'
import { getQueryString } from '@/utils/tools'
import { handleBuryingEvent } from '@/hooks'
import userStore from './modules/user'
import styleStore from './modules/style'
import pkStore from './modules/pk'

// token优先读取参数后边的
const token = getQueryString('token')
  ? getQueryString('token')
  : localStorage.getItem('token')
if (token) {
  localStorage.setItem('token', token.trim())
}

let orgId = getQueryString('orgid')
  ? getQueryString('orgid')
  : localStorage.getItem('orgId')
if (orgId) {
  localStorage.setItem('orgId', orgId)
} else {
  orgId = 29
}

let inputCatch = {}
if (localStorage.getItem('inputCatch')) {
  inputCatch = JSON.parse(localStorage.getItem('inputCatch'))
}

let inputCacheListObj = {}
if (localStorage.getItem('inputCacheListObj')) {
  inputCacheListObj = JSON.parse(localStorage.getItem('inputCacheListObj'))
}

export default createStore({
  state: {
    answers: [],
    personAnswers: [],
    quesList: [],
    studyQuesList: [],
    swiperList: [],
    quseInfo: null,
    quseSetting: null,
    reviewList: [],
    token: token,
    btnText: {
      quesBtn: '开始报名',
      personalBtn: '',
      adminBtn: '',
      mockBtn: '模拟考试',
      studyBtn: '试题学习',
      examBtn: '正式考试',
      explainBtn: '试题说明',
      rankBtn: '参赛排行',
      scoreBtn: '我的成绩',
      infoBtn: '个人信息',
      recordBtn: '答卷记录',
      certificateBtnText: '我的证书',
      quesRecordBtnText: '',
      compBtnText: '开始闯关',
      otherBtn: '其他',
      otherUrl: '',
      btnSort: [],
      moreBtnsShow: '0',
      moreBtnList: [],
    },
    startTime: new Date(),
    isPreview: getQueryString('isPreview')
      ? Number(getQueryString('isPreview'))
      : 0,
    orgId: orgId,
    unitId: localStorage.getItem('unitId'),
    activeId: localStorage.getItem('activeId'),
    answerCount: {
      leftTimes: 1,
      shareFlag: false,
    },
    shareInfo: {
      shareTitle: document.title,
    },
    inputCacheListObj: inputCacheListObj,
    // 用户个人题型相关信息
    userSelection: null,
    // TEMP
    type: '',
    inputCatch: inputCatch,
    // 绑定的模板信息
    moduleInfo: null,
    //  排行配置
    rankConfig: null,
    // 是否拦截
    isBlock: false,
    // admin管理树
    adminTree: null,
    // 是否有查看填报管理的权限
    hasAdminAuth: false,
    // 结果页提示语
    resultTip: '',
  },
  mutations: {
    setHasAdminAuth(state, payload) {
      const { data } = payload
      state.hasAdminAuth = data
    },
    // 设置admin管理树
    setAdminTree(state, payload) {
      const { data } = payload
      state.adminTree = data
    },
    // TEMP
    setType(state, payload) {
      const { data } = payload
      state.type = data
    },
    setIsBlock(state, isBlock) {
      state.isBlock = isBlock
    },
    setRankConfig(state, { data }) {
      state.rankConfig = data
    },
    setModuleInfo(state, payload) {
      const { data } = payload
      state.moduleInfo = data

      if (!this.state.adminTree) {
        this.dispatch('getAdminTree')
      }
    },
    setUserSelection(state, payload) {
      const { data } = payload
      state.userSelection = data
    },
    setInputCatch(state, payload) {
      const { value, key } = payload
      state.inputCatch[key] = value
      localStorage.setItem('inputCatch', JSON.stringify(inputCatch))
    },
    setInputCacheListObj(state, payload) {
      const { obj } = payload
      state.inputCacheListObj = obj
      localStorage.setItem('inputCacheListObj', JSON.stringify(obj))
    },
    setToken(state, payload) {
      const { token } = payload
      state.token = token
      // localStorage.setItem('token', token)
      this.dispatch('fetchHasAdminAuth')
    },
    setBtnText(state, payload) {
      const { personalBtn } = payload
      const { adminBtn } = payload
      Object.keys(payload).forEach((key) => {
        // 这两特殊，通过这两个判断是否显示
        if (personalBtn !== undefined) {
          state.btnText.personalBtn = personalBtn
        } else if (adminBtn !== undefined) {
          state.btnText.adminBtn = adminBtn
        } else {
          state.btnText[key] = payload[key]
        }
      })
    },
    setShareInfo(state, payload) {
      const { data } = payload
      state.shareInfo = data
    },
    setAnswerCount(state, payload) {
      const { data } = payload
      state.answerCount = data
    },
    setStartTime(state, payload) {
      const { time } = payload
      state.startTime = time
    },
    setUnitId(state, payload) {
      const { unitId } = payload
      state.unitId = unitId
      localStorage.setItem('unitId', unitId)
    },
    setActiveId(state, payload) {
      const { activeId } = payload
      state.activeId = activeId
      localStorage.setItem('activeId', activeId)
    },
    setPersonAnswers(state, payload) {
      const { list } = payload
      state.personAnswers = list
    },
    setSwiperList(state, payload) {
      const { list } = payload
      state.swiperList = list
    },
    initQuesList(state, payload) {
      const { list } = payload
      state.quesList = list
    },
    initStudyQuesList(state, payload) {
      const { list } = payload
      state.studyQuesList = list
    },
    initQuesInfo(state, payload) {
      const { data } = payload
      state.quseInfo = data
    },
    initQuseSetting(state, payload) {
      const { data } = payload
      state.quseSetting = data
    },
    initAnswers(state, payload) {
      const { length } = payload
      state.answers = Array(length)
    },
    changeAnswers(state, payload) {
      const { index, data } = payload
      state.answers[index] = data
    },
    setReviewList(state, payload) {
      const { data } = payload
      state.reviewList = data
    },
  },
  actions: {
    // 获取管理树
    async getAdminTree({ commit }, payload) {
      const res = await getSchoolListByUser()

      if (res.ok) {
        try {
          const data = JSON.parse(res.data.manageInfo)
          commit('setAdminTree', { data })
        } catch (error) {}
      }
    },
    // 获取是否有管理权限
    async fetchHasAdminAuth({ commit }, payload) {
      const res = await getAdminAuth({
        token: this.state.token,
      })

      if (res.ok) {
        commit('setHasAdminAuth', { data: res.data })
      }
    },
  },
  getters: {
    // 是否显示填报前弹窗
    isShowBefore: (state) => {
      return Boolean(state.quseInfo?.popupStatus === 2)
    },
    // 是否显示题型
    isShowType: (state) => {
      return Boolean(state.quseInfo?.typeStatus === 1)
    },
    // 获取是否有管理权限
    getHasAdminAuth: (state) => {
      return state.hasAdminAuth
    },
    // 获取管理树
    getAdminTree: (state) => {
      return state.adminTree
    },
    // TEMP
    getType: (state) => {
      return state.type
    },
    getIsBlock: (state) => {
      return state.isBlock
    },
    getRankConfig: (state) => {
      return state.rankConfig
    },
    getModuleInfo: (state) => {
      return state.moduleInfo
    },
    getUserSelection: (state) => {
      return state.userSelection
    },
    getInputCatch: (state) => {
      return state.inputCatch
    },
    getInputCacheListObj: (state) => {
      return state.inputCacheListObj
    },
    getBtnText: (state) => {
      // pk特殊处理
      if (state?.quseSetting?.isLevel === 3) {
        if (state.btnText?.examBtn === '正式考试' || !state.btnText?.examBtn) {
          state.btnText.examBtn = '开始PK'
       }
      }
      return state.btnText
    },
    getShareInfo: (state) => {
      return state.shareInfo
    },
    getIsPreview: (state) => {
      return state.isPreview
    },
    getAnswerCount: (state) => {
      return state.answerCount
    },
    getOrgId: (state) => {
      return state.orgId
    },
    getUnitId: (state) => {
      return state.unitId
    },
    getActiveId: (state) => {
      return state.activeId
    },
    getToken: (state) => {
      return state.token
    },
    getStartTime: (state) => {
      return state.startTime
    },
    getQuesList: (state) => {
      return state.quesList
    },
    getStudyQuesList: (state) => {
      return state.studyQuesList
    },
    getQuesInfo: (state) => {
      return state.quseInfo
    },
    getQuesSetting: (state) => {
      return state.quseSetting
    },
    getSwiperList: (state) => {
      return state.swiperList
    },
    getAnswers: (state) => {
      return state.answers
    },
    getPersonAnswers: (state) => {
      return state.personAnswers
    },
    getReviewList: (state) => {
      return state.reviewList
    },
  },
  modules: {
    styleStore,
    pkStore,
    userStore
  }
})
